import { render, staticRenderFns } from "./select_product_in.vue?vue&type=template&id=5156d8e2&scoped=true&"
import script from "./select_product_in.vue?vue&type=script&lang=js&"
export * from "./select_product_in.vue?vue&type=script&lang=js&"
import style0 from "./select_product_in.vue?vue&type=style&index=0&id=5156d8e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5156d8e2",
  null
  
)

export default component.exports